import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import background from '../assets/background-new.png';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Link from '@material-ui/core/Link';
import { Typography, useScrollTrigger } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    minWidth: '100vw',
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  panel: {
    height: '650px',
    backgroundColor: '#FCFCFC',
    borderRadius: '8px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '30px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '640px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '960px',
    },
  },
  content: {
    width: '90%',
    margin: 'auto',
    [theme.breakpoints.up('md')]: {
      width: '600px',
    },
    height: '300px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    '& h1': {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
    '& h2': {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
    '& p': {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },
  status: {
    marginTop: '75px',
    margin: 'auto',
    width: '90%',
    [theme.breakpoints.up('md')]: {
      width: '400px',
    },
  },
  acceptedButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'center',
    marginTop: '50px',
  },
  btn: {
    width: '90%',
    [theme.breakpoints.up('md')]: {
      width: '300px',
    },
    marginTop: '25px',
    fontSize: 18,
    lineHeight: '23px',
    borderRadius: '4px',
    textAlign: 'center',
    textTransform: 'none',
    letterSpacing: '-0.04rem',
  },
  attendingButtons: {
    margin: '5px',
    padding: '5px',
    width: '300px',
    height: '50px',
    borderRadius: '8px',
  },
  yesAttendingButton: {
    background: '#129F23',
  },
  noNotAttendingButton: {
    background: '#A43B3B',
  },
  acceptedText: {
    fontFamily: 'DM Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '99/6%',
    textAlign: 'center',
    letterSpacing: '-0.04 em',
    color: '#464646',
  },
  logoutBtn: {
    backgroundColor: '#A43B3B',
    color: '#FFFFFF',
    borderRadius: '4px',
    fontSize: 24,
    fontWeight: 500,
    textTransform: 'none',
    width: '170px',
    '&:hover': {
      backgroundColor: '#A43B40',
    },
  },
  logo: {
    position: 'absolute',
    bottom: '30px',
    left: '60px',
    color: theme.palette.primary.main,
    '& > span': {
      float: 'left',
      fontWeight: 600,
      paddingTop: '12px',
      paddingLeft: '10px',
    },
    '& > img': {
      height: '50px',
      float: 'left',
    },
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  attendingStatus: {
    color: '#129F23 !important',
  },
  withdrawnStatus: {
    color: '#697CB5 !important',
  },
  withdrawnBtn: {
    width: '90%',
    height: '50px',
    marginTop: '30px',
    fontSize: 20,
  },
  confirmWithdrawn: {
    marginRight: '15px',
  },
}));

export default function () {
  const history = useHistory();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState({});
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    // Check for user auth
    const link =
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_DROPLET_URL + '/api/user'
        : 'http://localhost:8080/api/user';
    axios
      .get(link, {
        withCredentials: true,
      })
      .then((response) => {
        setUser(response.data.user);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        history.push('/login');
      });
  }, []);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const openWithdrawnModal = () => {
    return (
      <Modal
        show={openModal}
        onHide={() => handleCloseModal()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Are you sure you want to withdraw? This action cannot be undone!
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button
            className={classes.confirmWithdrawn}
            variant="contained"
            color="primary"
            onClick={() => {
              changeStatus('Withdrawn');
              setUser({ ...user, status: 'Withdrawn' });
              handleCloseModal();
            }}>
            Confirm
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleCloseModal();
            }}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const renderContent = (status) => {
    switch (status) {
      case 'Account Created':
        return (
          <>
            <h2>No Application Submitted</h2>
            <p>Applications are now closed</p>
            {/* <Link href="/application">
              <Button
                className={classes.btn}
                variant="contained"
                color="primary">
                Start Application
              </Button>
            </Link> */}
          </>
        );
      case 'Application in Progress':
        return (
          <>
            <h2>Application in Progress</h2>
            <p>Applications are now closed</p>
            {/* <Link href="/application">
              <Button
                className={classes.btn}
                variant="contained"
                color="primary">
                Continue Application
              </Button>
            </Link> */}
          </>
        );
      case 'Application Received':
        return <h2>Application Recieved</h2>;
      case 'Accepted':
        return (
          <div>
            <h2>Accepted</h2>
            <div className={classes.acceptedButtonsContainer}>
              <Button
                className={`${classes.btn} 
                  ${classes.attendingButtons}
                  ${classes.yesAttendingButton}`}
                variant="contained"
                color="primary"
                onClick={() => {
                  setUser({ ...user, status: 'Attending' });
                  changeStatus('Attending');
                }}
                type="submit">
                I'm Attending
              </Button>
              <Button
                variant="contained"
                className={`${classes.btn} 
                  ${classes.attendingButtons}
                  ${classes.noNotAttendingButton}`}
                color="primary"
                onClick={() => {
                  handleOpenModal();
                }}
                type="submit">
                I'm Not Attending
              </Button>
              {openWithdrawnModal()}
            </div>
            <Typography variant="h4" className={classes.acceptedText}>
              You must provide a response by the date in your email
            </Typography>
          </div>
        );
      case 'Waitlist':
        return <h2>Waitlist</h2>;
      case 'Rejected':
        return <h2>Rejected</h2>;
      case 'Attending':
        return (
          <>
            <h2 className={classes.attendingStatus}>Attending</h2>
            <Button
              onClick={() => {
                handleOpenModal();
              }}
              className={`${classes.withdrawnBtn} ${classes.logoutBtn}`}
              variant="contained"
              color="primary">
              I'm no longer attending
            </Button>
            {openWithdrawnModal()}
          </>
        );
      case 'Withdrawn':
        return <h2 className={classes.withdrawnStatus}>Withdrawn</h2>;
      default:
        return <div></div>;
    }
  };

  const logOut = () => {
    const link =
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_DROPLET_URL + '/api/user/logout'
        : 'http://localhost:8080/api/user/logout';
    axios
      .post(
        link,
        {
          ...user,
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        history.push('/login');
      })
      .catch((error) => {});
  };

  const changeStatus = (status) => {
    const link =
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_DROPLET_URL + '/api/user/changeStatus'
        : 'http://localhost:8080/api/user/changeStatus';
    axios
      .post(
        link,
        {
          email: user.email,
          status,
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        setUser({ ...user, status });
      })
      .catch((error) => {});
  };

  return (
    <div className={classes.root}>
      <div className={classes.panel}>
        {isLoading ? (
          <div className={classes.loader}>
            <Spinner variant="primary" animation="border" />
          </div>
        ) : (
          <>
            <Button
              onClick={() => {
                logOut();
              }}
              className={classes.logoutBtn}
              variant="contained"
              color="primary">
              Log Out
            </Button>
            <div className={classes.content}>
              <h1>Welcome back, {user.firstname}</h1>
              {user.lastUpdated && user.lastUpdated.length > 0 && (
                <p style={{ color: 'black' }}>
                  LAST UPDATE: {user.lastUpdated}
                </p>
              )}
              <div className={classes.status}>
                <p>STATUS</p>
                {renderContent(user.status)}
              </div>
            </div>
            <div className={classes.logo}>
              <img src={require('../assets/hw-logo.png')} />
              <span>HACK WESTERN 7</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/**
 * Account Created
 * Application Received
 * Accepted
 * Waitlist
 * Rejected
 */
